import { queryOptions } from '@tanstack/react-query';
import { notificacaoService } from './services/notificacaoService';

export const notificacoesQueries = {
  all: () => ['notificacoes'] as const,

  list: () =>
    queryOptions({
      queryKey: [...notificacoesQueries.all(), 'list'] as const,
      queryFn: () => notificacaoService.list(),
      // Polling de 60s do sino (BR-13 / AC-4.4).
      refetchInterval: 60_000,
    }),
};
